import { Component, Prop, Vue } from 'vue-property-decorator'
import { i18n } from "@/i18n"

/**
 * Image styles mixin
 */
@Component
export default class extends Vue {
  @Prop({ type: String, default: "" })
  src!: string

  @Prop({ type: Number })
  width?: number

  @Prop({ type: Number })
  height?: number

  @Prop({ type: String, default: "" })
  alt!: string

  get computedSrc () {
    return i18n.t(this.src)
  }

  get computedAlt () {
    return i18n.t(this.alt)
  }
}
